import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineRobotIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M9 15a.9998.9998 0 0 0-.7071 1.7071A.9998.9998 0 0 0 10 16a1 1 0 0 0-1-1Zm-7-1a1.0002 1.0002 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm20 0a1.0001 1.0001 0 0 0-1 1v2a1.0001 1.0001 0 0 0 2 0v-2a1.0001 1.0001 0 0 0-1-1Zm-5-7h-4V5.72A2.0005 2.0005 0 0 0 14 4a1.9999 1.9999 0 1 0-4 0 1.9994 1.9994 0 0 0 1 1.72V7H7a3 3 0 0 0-3 3v9a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3Zm-3.28 2-.5 2h-2.44l-.5-2h3.44ZM18 19a1.0001 1.0001 0 0 1-1 1H7a1.0002 1.0002 0 0 1-1-1v-9a1 1 0 0 1 1-1h1.22L9 12.24a1 1 0 0 0 1 .76h4a.9996.9996 0 0 0 1-.76L15.78 9H17a1 1 0 0 1 1 1v9Zm-3-4a1 1 0 1 0-.0002 2A1 1 0 0 0 15 15Z"/>
  </SvgIcon>
}

export default LineRobotIcon
